import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { assetUrl } from '../Common/useEntries';
import { tokens } from '../../theme';

const useStyles = makeStyles((theme) => ({
    tile: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: 120,
        padding: theme.spacing(2),
        backgroundColor: tokens.white,
        border: `1px solid ${tokens.border}`,
        borderRadius: tokens.radius,
        transition: 'border-color 160ms ease, box-shadow 160ms ease',
        textDecoration: 'none',
        '&:hover': {
            borderColor: tokens.blue100,
            boxShadow: tokens.shadowSm,
        },
        '&:hover $logo': { filter: 'none', opacity: 1 },
        '&:focus-visible': { outline: `3px solid ${tokens.gold}`, outlineOffset: 2 },
    },
    logo: {
        maxWidth: '100%',
        maxHeight: 72,
        objectFit: 'contain',
        filter: 'grayscale(100%)',
        opacity: 0.75,
        transition: 'filter 160ms ease, opacity 160ms ease',
    },
    fallback: {
        fontSize: '0.875rem',
        fontWeight: 600,
        color: tokens.inkSoft,
        textAlign: 'center',
        lineHeight: 1.4,
    },
}));

/** Single development-partner logo tile, linking out to the partner's site. */
export default function ClientList({ menus }) {
    const classes = useStyles();
    const fields = menus?.fields;
    if (!fields) return null;

    const name = fields.Title || fields.title || fields.name || 'Development partner';
    const logo = assetUrl(fields.logopartner);
    const link = fields.linkpartner;

    const inner = logo ? (
        <img className={classes.logo} src={logo} alt={name} loading="lazy" />
    ) : (
        <span className={classes.fallback}>{name}</span>
    );

    if (!link) {
        return (
            <div className={classes.tile} title={name}>
                {inner}
            </div>
        );
    }

    return (
        <a
            className={classes.tile}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            title={name}
            aria-label={`${name} (opens in a new tab)`}
        >
            {inner}
        </a>
    );
}
